import React, { useState } from 'react';
import { Modal } from 'bootstrap';
import { toast } from 'react-toastify';
import HttpAPICall from '../../services/HttpAPICall';
import { ORG_API_BASE_URL_2 } from '../../services/TapApiUrls';
import TapIcon from '../../services/TapIcon';
import Status from '../../components/ui/Status';
import { useSelector } from 'react-redux';
import { logout } from '../../store/actions';

const ChangePasswordModal = (props, history) => {
    const { modalRef, userDetailData } = props
    const accessToken = useSelector(state => state.auth.access_token);
    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [savePasswordFormSubmitting, setSavePasswordFormSubmitting] = useState(false);
    const [changePasswordForm, setChangePasswordForm] = useState({
        current_password: "",
        password: '',
        password_confirmation               : ''
  });

  const userPassResetUrl        =       ORG_API_BASE_URL_2 + '/user/profile/change_password';

  const formInputHandler        =       (e) => {
    setChangePasswordForm({
      ...changePasswordForm,
      [e.target.name]: e.target.value
    });
  };

  const changePasswordFormSubmit =      (e) => {
    e.preventDefault();

        if (changePasswordForm.password === changePasswordForm.password_confirmation) {
            setSavePasswordFormSubmitting(true);
            HttpAPICall.withAthorization('PUT', userPassResetUrl, accessToken, {}, { ...changePasswordForm }, (response) => {
                toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                if (modalRef.current) {
                    modalRef.current.hide();
                }
                setChangePasswordForm({ password: '', password_confirmation: '', current_password: '' });
                setTimeout(() => {
                   props.history.push("/logout");
                }, 5000);
            }).then(() => setSavePasswordFormSubmitting(false));
        } else {
            toast.error('The password confirmation does not match.', { position: toast.POSITION.TOP_RIGHT });
        }
    };

    return (
        <div className="modal fade" id="changePasswordModal" tabIndex="-1">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="changePasswordModalLabel">Change Password</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className='p-1 bg-light border-bottom'>
                        <table className='table table-sm mb-0 table-borderless text-sm'>
                            <tbody>
                                <tr>
                                    <td style={{ width: "26%" }}> Name   </td>
                                    <th>{userDetailData ? `${userDetailData.full_name}` : "-"}</th>
                                </tr>
                                <tr>
                                    <td>Role </td><th>{userDetailData && userDetailData.role ? `${userDetailData.role.role} ` : "-"}</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "26%" }}> Status  </td>
                                    <th>{userDetailData ? <Status color={userDetailData.status_color_code}>{userDetailData.status_text}</Status> : "-"}</th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <form onSubmit={changePasswordFormSubmit} id="changePasswordForm">
                        <div className="modal-body">
                            <div className="row mb-3">
                                <label className="col-sm-3 col-form-label col-form-label-sm require">Current Password</label>
                                <div className="col-sm-6">
                                    <input
                                        type={showCurrentPassword ? 'text' : 'password'}
                                        name="current_password"
                                        onChange={formInputHandler}
                                        value={changePasswordForm.current_password}
                                        className="form-control form-control-sm"
                                        required={true}
                                        autoComplete="off"
                                        minLength={4}
                                        maxLength={50}
                                    />
                                </div>
                                <div className='col-sm-3'>
                                    <div className="form-check form-check-inline">
                                        <input
                                            name="showCurrentPassword"
                                            type="checkbox"
                                            checked={showCurrentPassword}
                                            onChange={(e) => {
                                                setShowCurrentPassword(e.target.checked);
                                            }}
                                            className="form-check-input"
                                            id="showCurrentPassword"
                                        />
                                        <label className="form-check-label" htmlFor="showCurrentPassword">Show Password</label>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-3 col-form-label col-form-label-sm require">New Password</label>
                                <div className="col-sm-6">
                                    <input
                                        type={showNewPassword ? 'text' : 'password'}
                                        name="password"
                                        value={changePasswordForm.password}
                                        onChange={formInputHandler}
                                        className="form-control form-control-sm"
                                        required={true}
                                        autoComplete="off"
                                        minLength={4}
                                        maxLength={50}
                                    />
                                </div>
                                <div className='col-sm-3'>
                                    <div className="form-check form-check-inline">
                                        <input
                                            name="showNewPassword"
                                            type="checkbox"
                                            checked={showNewPassword}
                                            onChange={(e) => {
                                                setShowNewPassword(e.target.checked);
                                            }}
                                            className="form-check-input"
                                            id="showNewPassword"
                                        />
                                        <label className="form-check-label" htmlFor="showNewPassword">Show Password</label>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-3 col-form-label col-form-label-sm require">Confirm Password</label>
                                <div className="col-sm-6">
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        name="password_confirmation"
                                        value={changePasswordForm.password_confirmation}
                                        onChange={formInputHandler}
                                        className="form-control form-control-sm"
                                        required={true}
                                        minLength={4}
                                        maxLength={50}
                                        autoComplete="off"
                                    />
                                </div>
                                <div className='col-sm-3'>
                                    <div className="form-check form-check-inline">
                                        <input
                                            name="showPassword"
                                            type="checkbox"
                                            checked={showPassword}
                                            onChange={(e) => {
                                                setShowPassword(e.target.checked);
                                            }}
                                            className="form-check-input"
                                            id="show_password"
                                        />
                                        <label className="form-check-label" htmlFor="show_password">Show Password</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer d-flex justify-content-between row">
                            <div className="col-8 text-start">
                                <div className="form-text">#
                                    Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character
                                </div></div>
                            <div className="col-3 text-end ">
                                <button type="button" className="btn btn-secondary me-2" disabled={savePasswordFormSubmitting} data-bs-dismiss="modal">Close</button>
                                <button type="submit" className="btn btn-primary " disabled={savePasswordFormSubmitting}>
                                    Save {savePasswordFormSubmitting ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : null}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ChangePasswordModal;